import './app.js'
import Api from './apis/api.js'
import RecaptchaV3 from './recaptcha.js'
import { setError, clearError } from './forms.js'

const form = document.getElementById( 'tax-form' )
const btn = form.querySelector( '[type="submit"]' )

form.addEventListener( 'submit', e => {
  e.preventDefault()

  const inputRegion = form.elements.region
  const inputPower = form.elements.power
  const inputEmail = form.elements.email
  const params = {}

  if( !inputRegion.value )
  {
    setError( 'Seleziona una regione', inputRegion)
    return
  }
  else clearError( inputRegion )

  params.region = inputRegion.value

  if( inputPower.value < 20 || inputPower.value > 1000 )
  {
    setError( 'Inserire una potenza in KW tra (20 e 1000)', inputPower )
    return
  }
  else clearError( inputPower )

  params.power = inputPower.value

  if( !inputEmail.value )
  {
    setError( 'Inserire un indirizzo email', inputEmail )
    return
  }
  else clearError( inputEmail )

  params.email = inputEmail.value

  btn.disabled = true
  btn.classList.add( 'loading' )

  RecaptchaV3.send( recaptcha_token => {
    Api.post( 'camper/tax', {
      ...params,
      recaptcha_token
    })
      .then( () => {
          form.replaceWith( 'Il calcolo è stato inviato correttamente.' )
      })
      .catch( ({ message }) => {
        setError( message, inputRegion )
      })
      .finally( () => {
        btn.disabled = false
        btn.classList.remove( 'loading' )
      })
  })
})
